export function formatBoxPreview(qty, qpb, t) {
  const q = Number(qty);
  const per = Number(qpb);
  if (!per || per <= 0 || !q || q < per) return null;
  const boxes = Math.floor(q / per);
  const loose = q - boxes * per;
  if (loose === 0) {
    return t('operator.pages.putaway.allocation.box_preview_full', {
      boxes,
      defaultValue: '= {{boxes}} 箱',
    });
  }
  return t('operator.pages.putaway.allocation.box_preview', {
    boxes,
    loose,
    defaultValue: '= {{boxes}} 箱 + {{loose}} 件',
  });
}
